import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { DocumentWrapper } from 'components';
import { formatterContextValues } from 'utils/documentFormatting';

import messages from './messages';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <>
      <div style={{ padding: '12px 16px' }}>
        <button
          type="button"
          onClick={() => navigate('/my-account')}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit',
            fontSize: 14,
            color: 'inherit',
          }}
        >
          ← Back to account
        </button>
      </div>
      <DocumentWrapper>
        <FormattedMessage
          {...messages.main}
          values={{
            ...formatterContextValues,
          }}
        />
      </DocumentWrapper>
    </>
  );
};

export default PrivacyPolicy;